import { Component, OnDestroy, OnInit, Output } from '@angular/core';     //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
import { faAngleLeft, faAngleRight, faFolderOpen, faFolderPlus } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from './project.service';
import { SharedService } from '../helper/shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild } from '@angular/core';
import { UserInfoService } from '../user-info/user-info.service';
import { formatDate } from '@angular/common';
import { isNullOrEmpty, isNullOrUndefined } from '../helper/validation';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
//Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
import { LoginService } from '../login/login.service';
import { ConfirmationdialogueService } from '../confirmationdialogue/confirmationdialogue.service';
import { EventEmitter } from '@angular/core';
//Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  @ViewChild('projectOverwriteConfirm', { static: false }) myProjOverwriteModal: any;
  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
  @ViewChild('projectConfirmSaveChanges', { static: false }) myProjConfirmSaveChangesModal: any;
  @Output() exposeChild: EventEmitter<String> = new EventEmitter<String>();
  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faFolderOpen = faFolderOpen;
  faFolderPlus = faFolderPlus;
  activeFlag: number = 0;
  visible = false;
  Header = 'Project 1';
  ButtonAction = 'Save';
  confirmHeading = "Confirmation";
  path = this.route.snapshot.queryParams['path'];
  confirmBody = 'Do you really want to save the project?';
  stage = ['customerInfo', 'siteInfo', 'cleanroom', 'solutions', 'results', 'reportGen'];

  closeResult: string;
  currentFolderID = 0;
  currentFolderName = 0;
  lastRecordID = 0;
  viewFlag = '';

  calculationType = "";  //Modified by JW(2022-08-16): select calculation type

  CreateNewFolder = false;
  newFolderName = '';
  folderPath: any = [];
  allProjects: any = [];
  projects: any = [];
  availableFolders: any = [];

  saving = false;
  strSaveConfirmMsg = "";

  constructor(
    public route: ActivatedRoute,
    private sharedService: SharedService,
    public projectService: ProjectService,
    private toast: ToastrService,
    private modalService: NgbModal,
    private userInfoService: UserInfoService,
    private router: Router,
    private httpService: HttpClient,
    //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
    private loginService: LoginService,
    private confirmationDialogService: ConfirmationdialogueService
    //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end

  ) { }

  ngOnInit() {
    switch (this.route.snapshot.url[0].path) {
      case "project":
        if (this.projectService.projectdetails.projectInfo === undefined) {
          this.router.navigate(["home"]);
        }
        if (this.activeFlag === undefined || this.activeFlag === 0) {
          this.activeFlag = 1;
          this.projectService.activePage = this.activeFlag;
        }
        break;

      case "importxml":
        this.Header = this.sharedService.ProjectToEdit.name;
        this.projectService.activePage = this.activeFlag;
        //Already assigned value this.sharedService.calculationType = "CLD";
        break;

      default:
        this.projectService.activePage = this.activeFlag;
        if (this.userInfoService.userData.UserId === 0 && this.userInfoService.userData.UserName === '') {
          if (this.projectService.projectdetails.projectInfo === undefined) {
            this.router.navigate(["home"]);
          }
        }
        //Already assigned value this.sharedService.calculationType = "CLD"; //Modified by PP(2022-11-16) : Load project unable to go results page due to ASTM/CLD in project.component.html
        break;
    }

    //Modified by PS(2023-03-22): MCCLD 2023-Improve performance-START
    /*if (this.sharedService.GoToUsersClickPath) {
    } else {
      this.getProjects();
    }*/
    //Modified by PS(2023-03-22): MCCLD 2023-Improve performance-END

    if (this.sharedService.SavedUserClickPath != undefined) {
      for (var i = 0; i < this.sharedService.SavedUserClickPath.length; i++) {
        let tmpRec = {
          Title: this.sharedService.SavedUserClickPath[i].Title,
          ID: this.sharedService.SavedUserClickPath[i].ID,
        }
        this.folderPath.push(tmpRec);
        if (i == this.sharedService.SavedUserClickPath.length - 1) {
          this.lastRecordID = this.sharedService.SavedUserClickPath[i].ID;
        }
      }
      //this.getProjects(); //Modified by PS(2023-03-22): MCCLD 2023-Improve performance-START
    } else {
      this.folderPath.push({ 'Title': 'Home', 'ID': 0 });
    }

    //Modified by PP(2023-10-28) : No need to getProjects when userid = 0. For refreshing of page other than Home - START
    //this.getProjects();
    if (this.userInfoService.userData.UserId > 0) {
      this.getProjects();
    }
    //Modified by PP(2023-10-28) : No need to getProjects when userid = 0. For refreshing of page other than Home - END


    if (!isNullOrEmpty(this.projectService.projectdetails.ProjectName)) {
      this.Header = this.projectService.projectdetails.ProjectName;
    } else {
      this.Header = 'Project ' + this.route.snapshot.params['projectID'];
      if (this.sharedService.ProjectToEdit !== undefined) {
        if (this.sharedService.ProjectToEdit.name !== undefined) {
          if (this.sharedService.ProjectToEdit.name !== "") {
            this.Header = this.sharedService.ProjectToEdit.name;
          }
        }
      }
    }

    this.calculationType = this.sharedService.calculationType;   //Modified by JW(2022-08-16): select calculation type
    let userId = this.userInfoService.userData.UserId;
    if (userId === 0) {
      this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe(usrAccountInfo => {
        if (usrAccountInfo !== null) {
          if (usrAccountInfo !== undefined) {
            this.userInfoService.InsertUserData(usrAccountInfo);
            this.callGetProjectDropDownList();
          } else {
            this.toast.error("Failed to retrieve user information. Please reload the page.", "Error");
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }
      });
    } else {
      this.callGetProjectDropDownList();
    }
  }

  step(data: any) {
    let isValidLoginToken = this.canActivate(); //Modified by PP(2023-10-24): Check for timeout of logincode
    if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit' || this.route.snapshot.url[0].path.toLowerCase() == 'importxml' || this.activeFlag > data) {
      //Modified by JW(2022-08-24): validation check step on other page by clicking the tab-start
      // this.activeFlag = data;
      // this.projectService.activePage = this.activeFlag;

      //Modified by PP(2023-05-12) If click on previous tab then no validation done. Follow PREVIOUS click button - START
      // let result = this.projectService.checkValidation(this.activeFlag);
      // if (result === true) {
      //   this.activeFlag = data;
      //   this.projectService.activePage = this.activeFlag;
      // }
      if (this.activeFlag > data) { //Previous
        this.activeFlag = data;
        this.projectService.activePage = this.activeFlag;
      }

      if (this.activeFlag < data) { //Next
        let result = this.projectService.checkValidation(this.activeFlag);
        if (result === true) {
          this.activeFlag = data;
          this.projectService.activePage = this.activeFlag;
        }
      }
      //Modified by JW(2022-08-24): validation check step on other page by clicking the tab-end
      //Modified by PP(2023-05-12) If click on previous tab then no validation done. Follow PREVIOUS click button - END
    }
  }

  prevStep() {
    let isValidLoginToken = this.canActivate(); //Modified by PP(2023-10-24): Check for timeout of logincode
    if (this.activeFlag > 1) {
      if (this.sharedService.projectNotCalc) {
        if (this.projectService.projectdetails.contamination.gasDetails.length == 0) {
          //this.activeFlag -= 1; //To Contamination page
          this.activeFlag = 3; //To Contamination page
          this.projectService.activePage = this.activeFlag;
        } else {
          if (this.projectService.projectdetails.results === undefined) {
            //this.activeFlag -= 1; //To Contamination page
            this.activeFlag = 3; //To Contamination page
            this.projectService.activePage = this.activeFlag;
          }
        }

      } else {
        this.activeFlag -= 1;
        this.projectService.activePage = this.activeFlag;
      }
    }
  }

  prevStepORI() {
    if (this.activeFlag > 1) {
      this.activeFlag -= 1;
      this.projectService.activePage = this.activeFlag;
    }
  }

  nextStep() {
    let isValidLoginToken = this.canActivate(); //Modified by PP(2023-10-24): Check for timeout of logincode
    let result = this.projectService.checkValidation(this.activeFlag);
    if (result === true) {
      switch (this.projectService.projectdetails.projectInfo.calculationType) {
        case "ASTM":
          if (this.activeFlag < 5) {
            this.activeFlag = this.activeFlag + 1;
          }
          break;
        case "CLD":
          if (this.activeFlag < 6) {
            this.activeFlag = this.activeFlag + 1;
          }
          break;
      }
    }
  }

  showDataFromChild(data: any) { }

  onMouseClick(e: MouseEvent) {
    var headerMenuClass: any;
    headerMenuClass = document.getElementsByClassName('topbar');
    for (var i = 0; i < headerMenuClass.length; i++) {
      headerMenuClass[i].style.zIndex = '99';
    }
  }

  CheckProjectExist() {
    let ProjID = 0;
    let ProjName = "";
    if (this.projectService.projectdetails.projectId != undefined) {
      ProjID = this.projectService.projectdetails.projectId;
    } else {
      ProjID = 0;
    }

    if (this.projectService.projectdetails.projectInfo != undefined) {
      //Modified by PP(@023-06-09) : To use new keyed in name by user to check existence ProjName = this.projectService.projectdetails.projectInfo.projectName;
      ProjName = this.sharedService.headerProjectName; //Modified by PP(@023-06-09) : To use new keyed in name by user to check existence
      if (this.projectService.projectdetails.projectInfo.id > 0 && ProjID === 0) {
        ProjID = this.projectService.projectdetails.projectInfo.id;
      }
    } else {
      //Modified by PP(@023-06-09) : To use new keyed in name by user to check existence ProjName = this.projectService.projectdetails.projectInfo.projectName; //to recheck this line
      ProjName = this.sharedService.headerProjectName; //Modified by PP(@023-06-09) : To use new keyed in name by user to check existence 
    }

    this.sharedService.CheckProjExist(ProjName, ProjID, this.currentFolderID).subscribe(recExist => { // Modified by PP(2022-03-08) : To check the folder id from project component
      if (recExist !== null) {
        if (recExist) {
          this.modalService.open(this.myProjOverwriteModal, {
            ariaLabelledBy: 'modal-basic-title',
            centered: true,
            backdrop: 'static'
          }).result.then((result) => {
          }, (cancelOverWrite) => {
            this.closeResult = `Dismissed`;
          });
        } else {
          //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-start
          //this.ProceedSaveToDb();
          //if(this.sharedService.projectEditName!=='' && this.sharedService.projectEditName !== this.projectService.projectdetails.projectInfo.projectName){
          if (this.sharedService.headerProjectName !== '' && this.sharedService.headerProjectName !== this.projectService.projectdetails.projectInfo.projectName) {
            //this.projectService.projectdetails.projectInfo.projectName = this.sharedService.projectEditName;
            this.projectService.projectdetails.projectInfo.projectName = this.sharedService.headerProjectName;
            this.ProceedSaveToDb();
          } else {
            //if(this.sharedService.projectEditName===''){
            if (this.sharedService.headerProjectName === '') {
              //this.sharedService.projectEditName = this.projectService.projectdetails.projectInfo.projectName;
              this.sharedService.headerProjectName = this.projectService.projectdetails.projectInfo.projectName;
            }
            //this.strSaveConfirmMsg = 'Do You really want to save the changes in "' + this.sharedService.projectEditName + '" ?';
            this.strSaveConfirmMsg = 'Do You really want to save the changes in "' + this.sharedService.headerProjectName + '" ?';
            this.modalService.open(this.myProjConfirmSaveChangesModal, {
              ariaLabelledBy: 'modal-basic-title',
              centered: true,
              backdrop: 'static'
            }).result.then((result) => {
            }, (cancelOverWrite) => {
              this.closeResult = `Dismissed`;
            });
          }
        }
      } else {
        this.sharedService.redirectToLoginPage();
      }
    });
    //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)-end
  }


  addRemoveZIndex(WhichOption: any) {
    var headerMenuClass: any;
    switch (WhichOption) {
      case 'add':
        headerMenuClass = document.getElementsByClassName('topbar');
        for (var i = 0; i < headerMenuClass.length; i++) {
          headerMenuClass[i].style.zIndex = '99';
        }
        break;

      case 'remove':
        headerMenuClass = document.getElementsByClassName('topbar');
        for (var i = 0; i < headerMenuClass.length; i++) {
          if (headerMenuClass[i].style.zIndex == '-1') { //If User click again to remove the dropdown
            headerMenuClass[i].style.zIndex = '99';
          } else {
            headerMenuClass[i].style.zIndex = '-1';
          }
        }
        break;
    }
  }

  callGetProjectDropDownList() {
    if (isNullOrUndefined(this.sharedService.dataEntriesList)) {
      console.log("PS20230321 Check: => get ddl and default value -START => " + new Date());
      this.sharedService.getProjectDropdowns(this.userInfoService.userData.UserUnitId).subscribe(data => {
        this.sharedService.dataEntriesList = data;
        console.log("PS20230321 Check: => get ddl and default value -END => " + new Date());
        if (data !== null) {
          if (!isNullOrUndefined(data)) {
            //this.sharedService.dataEntriesList = this.sharedService.getDataListPerUserUnit(this.userInfoService.userData.UserUnitId);
            //this.sharedService.dataEntriesList = this.sharedService.UpdateDataEntries(this.userInfoService.userData.UserUnitId);
            if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit') {
              this.projectService.valid.customerInfo = 'Valid';
              this.projectService.valid = {
                'customerInfo': 'Valid',
                'siteInfo': 'Valid',
                'contamination': 'Valid',
                'solutions': 'Valid',
                'results': 'Valid',
                'reportGen': 'Valid',
              };
              this.activeFlag = 5;
            }
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }
      });
    } else {
      //this.projectservice.listData = this.sharedService.dataEntriesList;
      if (this.route.snapshot.url[0].path.toLowerCase() == 'projectedit') {
        if (this.sharedService.projectNotCalc == true) {
          if (this.calculationType === 'ASTM') {
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 3;
          } else { //CLD
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Invalid',
              'reportGen': 'Invalid',
            };
            this.activeFlag = 4;
          }
        } else {
          if (this.calculationType === 'ASTM') {
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 4;
          } else { //CLD
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 5;
          }
        }
      }

      if (this.route.snapshot.url[0].path.toLowerCase() == 'importxml') {
        if (this.sharedService.projectNotCalc == true) {
          if (this.calculationType === 'ASTM') {
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 3;
          } else { //CLD
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 4;
          }
        } else {
          if (this.calculationType === 'ASTM') {
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 4;
          } else { //CLD
            this.projectService.valid.customerInfo = 'Valid';
            this.projectService.valid = {
              //'customerInfo': 'Valid',
              'siteInfo': 'Valid',
              'contamination': 'Valid',
              'solutions': 'Valid',
              'results': 'Valid',
              'reportGen': 'Valid',
            };
            this.activeFlag = 5;
          }
        }
      }
    }

    console.log("last line of callGetProjectDropDownList()" + new Date());
    if (isNullOrUndefined(this.sharedService.FilterChemicals)) {
      //Definitely not finish fetching media as too many medias. This technique will not work. It only calls the same function twice and will slow down the performance.
      //console.log("calling FetchContamination_FilterGrouping() from callGetProjectDropDownList " + new Date());
      //this.sharedService.FetchContamination_FilterGrouping(); //To call 2nd API. Solutions page sometimes unable to get media to load. 2nd API has media
      //this.sharedService.RetrieveDDL(); //123
      //this.sharedService.FetchContamination_FilterGrouping(); //abc
    }
  }

  getProjects() {
    let currentFolder = this.sharedService.SavedUserClickPath.length;
    if (this.sharedService.GoToUsersClickPath) {
      switch (currentFolder) {
        case 1:
          this.getFolder(0, "Home", undefined);
          break;

        case 2:
          this.getFolder(0, "Home", undefined);
          break;

        default:
          this.getFolder(this.sharedService.SavedUserClickPath[currentFolder - 2].ID, this.sharedService.SavedUserClickPath[currentFolder - 2].Title, undefined);
          break;
      }
    } else {
      this.getFolder(0, "Home", undefined);
    }
  }

  createFolder(NewFolderName) {
    if (NewFolderName != '') {
      this.sharedService.CreateNewFolder(this.currentFolderID, NewFolderName).subscribe(data => {

        //Modified by PP(2023-10-24): Check for timeout of logincode - START
        if (data !== null) {
          if (data.Process.Fail === false) {
            this.toast.success("Folder created successfully", "Success");
            let indexToPop = 0;
            for (var x = 0; x < this.path.length; x++) {
              if (this.path[x].ID == this.currentFolderID) {
                indexToPop = x;
              }
            }
            this.popPathArray(indexToPop - 1);
            if (data.Folder.childFolder !== undefined) {
              if (data.Folder.childFolder.length > 0) {
                let index = data.Folder.childFolder.findIndex(itm => itm.FolderName === NewFolderName);
                if (index > -1) {
                  let folder = data.Folder.childFolder[index];
                  this.getFolder(this.currentFolderID, this.currentFolderName, folder.ID);
                }
              }
            }
          } else {
            this.toast.warning("Something went wrong during creation of folder", "Warning");
          }
        } else {
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.toast.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]); 
        }
        //Modified by PP(2023-10-24): Check for timeout of logincode - END

      })
    } else {
      this.toast.warning('Folder name cannot be empty', 'Error');
    }
  }

  getFolder(pFolderID, pFolderName, openFolderId) {
    console.log("PS20230321 Check: => fetch app folders -START => " + new Date());
    this.sharedService.GetApplicationFolder(pFolderID, true).subscribe(
      res => {
        console.log("PS20230321 Check: => fetch app folders -END => " + new Date());

        //Modified by PP(2023-10-24): Check for timeout of logincode - START
        if (res !== undefined && res !== null) {
          if (res.ID === 0 && res.ParentID === 0 && res.TotalFile === 0 && res.childFolder.length === 0) {
            if (this.sharedService.blnCreateNewProject) {
              this.sharedService.blnCreateNewProject = false;
            } else {
              this.toast.warning("No saved projects in your profile.", "Warning");
            }
          } else {
            this.sharedService.AllFilesAndFolders = res;
            let payload = this.sharedService.assignToNewFolderStruc(pFolderID);
            this.viewFlag = 'All';
            this.allProjects = payload;
            this.allProjects.forEach(element => {
              try {
                element['newDate'] = formatDate(element.TimeStamp, "dd MMMM yyyy", 'en-US');;
              } catch {
                element['newDate'] = element.TimeStamp.substring(0, element.TimeStamp.indexOf(" "));
              }
            });
            this.projects = this.allProjects;

            this.availableFolders = [];
            for (var i = 0; i < this.allProjects.length; i++) {
              if (this.allProjects[i].Type == 'Folder') {
                let tmpRec = {
                  Fname: this.allProjects[i].Fname,
                  ID: this.allProjects[i].ID,
                  Name: this.allProjects[i].Name,
                  newDate: this.allProjects[i].newDate,
                  ParentID: this.allProjects[i].ParentID,
                  Path: this.allProjects[i].Path,
                  ServerDB: this.allProjects[i].ServerDB,
                  TimeStamp: this.allProjects[i].TimeStamp,
                  TotalFile: this.allProjects[i].TotalFile,
                  Type: this.allProjects[i].Type
                }
                this.availableFolders.push(tmpRec);
              }
            }
            if (pFolderID > 0 && !this.sharedService.GoToUsersClickPath) {
              this.path.push({ 'Title': pFolderName, 'ID': pFolderID });
            }
            this.currentFolderID = pFolderID;
            this.currentFolderName = pFolderName;

            if (this.sharedService.GoToUsersClickPath) {
              if (this.sharedService.SavedUserClickPath != undefined) {
                for (var i = 0; i < this.allProjects.length; i++) {
                  if (this.allProjects[i].ID == this.lastRecordID) {
                    let tmpRec = {
                      Fname: this.allProjects[i].Fname,
                      ID: this.allProjects[i].ID,
                      Name: this.allProjects[i].Name,
                      newDate: this.allProjects[i].newDate,
                      ParentID: this.allProjects[i].ParentID,
                      Path: this.allProjects[i].Path,
                      ServerDB: this.allProjects[i].ServerDB,
                      TimeStamp: this.allProjects[i].TimeStamp,
                      TotalFile: this.allProjects[i].TotalFile,
                      Type: this.allProjects[i].Type
                    }
                    this.openChild(tmpRec, false);
                  }
                }
              }
            }
            if (openFolderId !== undefined) {
              let index = this.allProjects.findIndex(itm => itm.ID === openFolderId && itm.Type === 'Folder');
              if (index > -1) {
                let folder = this.allProjects[index];
                this.openChild(folder, false);
              }
            }
          }
        } else {
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.toast.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]); 
        }
        //Modified by PP(2023-10-24): Check for timeout of logincode - END
      },
      err => {
        this.toast.error("Failed to retrieve Projects in Folders. Please try again.", "Error");
      }
    );
  }

  openChild(id, SearchParentID) {
    this.currentFolderID = id.ID;
    this.currentFolderName = id.Fname;

    if (id.Fname == undefined || id.Fname == '') {
      this.currentFolderName = id.Title;
    }

    if (SearchParentID) {
      this.getFolder(id.ID, id.Title, undefined);
    }

    if (!SearchParentID) {
      let payload = this.sharedService.getChildFolders(id.ID);
      if (payload == undefined || payload == null || payload.length == 0) {
        this.getFolder(id.ID, id.Title, undefined);
      }

      if (payload !== undefined && payload !== null) {
        this.allProjects = payload;
        console.log(this.allProjects);
        this.allProjects.forEach(element => {
          try {
            element['newDate'] = formatDate(element.TimeStamp, "dd MMMM yyyy", 'en-US');;
          } catch {
            element['newDate'] = element.TimeStamp.substring(0, element.TimeStamp.indexOf(" "));
          }
        });
        this.projects = this.allProjects.filter(element => {
          return element.Type == 'Folder';
        });

        this.availableFolders = this.allProjects.filter(element => {
          return element.Type == 'Folder';
        });

        var FolderExist = false;
        for (var i = 0; i < this.folderPath.length; i++) {
          if (this.folderPath[i].ID == id.ID) {
            FolderExist = true;
          }
        }
        if (!FolderExist) {
          if (id.Fname == undefined || id.Fname == '') {
            this.folderPath.push({ 'Title': id.Title, 'ID': id.ID });
          } else {
            this.folderPath.push({ 'Title': id.Fname, 'ID': id.ID });
          }
        }
      }
    }
  }

  goTofolder(item, index) {
    this.sharedService.GoToUsersClickPath = false;
    if (index == 0) {
      this.getProjects();
      this.popPathArray(index);
    }
    else if (index != this.folderPath.length - 1) {
      this.openChild(item, true);
      this.popPathArray(index);
    }
  }

  popPathArray(index) {
    for (let i = this.folderPath.length - 1; i > index; i--) {
      this.folderPath.pop();
    }
  }

  ProceedSaveToDb() {
    this.saving = true;
    this.addRemoveZIndex('add');
    this.modalService.dismissAll();
    let blnValidEntries = this.sharedService.ValidateDataEntries(this.projectService.projectdetails);
    if (blnValidEntries === true) {
      this.projectService.projectdetails.projectInfo.folderId = this.currentFolderID;

      this.projectService.projectdetails.projectInfo.id = 0;
      this.sharedService.ServerData = this.sharedService.CompileDataForCalculation(this.projectService.projectdetails, 0);
      var continueUploading = true;
      this.sharedService.CountTotalSeqForUploadingParams(this.sharedService.ServerData, 'UPLOAD MCCLD PARAMS TO SERVER');
      this.PrepareToUploadParams();
    }
  }

  PrepareToUploadParams() {
    this.projectService.projectdetails.projectInfo.folderId = this.currentFolderID;
    var dataToUpload = this.sharedService.generateStr();
    console.log("PS20230321 Check: => UploadServerData2TempStringStorage - START=> " + new Date());
    this.projectService.UploadServerData2TempStringStorage(dataToUpload).subscribe(res => {
      console.log("PS20230321 Check: => UploadServerData2TempStringStorage - END=> " + new Date());
      if (res) {
        this.sharedService.TempStringStorageTotalPass = this.sharedService.TempStringStorageTotalPass + 1;
        this.sharedService.ServerDataReady = true;
        this.sharedService.UploadingEntry = false;
        if (this.sharedService.TempStringStorageTotalPass + this.sharedService.TempStringStorageTotalFail !== this.sharedService.TempStringStorageTotalSeq) {
          this.sharedService.TempStringStorageCurrentSeq = this.sharedService.TempStringStorageCurrentSeq + 1;
          this.PrepareToUploadParams();
        } else {
          if (this.sharedService.TempStringStorageTotalPass === this.sharedService.TempStringStorageTotalSeq) {
            //this.projectService.PerformMCCLDCalculation(false, 0, false, false).subscribe(data => {
            //if (data) {
            console.log("PS20230321 Check: => save record -START=> " + new Date());
            this.projectService.SaveProjectToDb().subscribe(result => {
              console.log("PS20230321 Check: => save record -END=> " + new Date());
              if (result !== null) {
                if (result !== undefined) {

                  this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'SAVECALCULATION').subscribe(result => {                       
                    if (result) {}
                  });

                  let successMsg = "Project saved successfully";
                  let failedMsg = "Failed to save the current project to Database!";
                  let tmp: any = result;
                  let aryResults: any = tmp.split(";");
                  let successSave = false;
                  if (aryResults.length > 1) {
                    if (aryResults[0] !== '' && aryResults[0] !== '0' && aryResults[1] === 'Save Db successful.') {
                      this.projectService.projectdetails.projectInfo.id = aryResults[0];
                      successSave = true;
                    }
                  }
                  if (successSave) {
                    var newPath = "";
                    for (var x = 0; x < this.folderPath.length; x++) {
                      if (newPath == "") {
                        newPath = this.folderPath[x].Title + "/";
                      } else {
                        newPath = newPath + this.folderPath[x].Title + "/";
                      }
                    }

                    if (newPath != "" || newPath != undefined) {
                      this.projectService.projectdetails.NewPath = newPath;
                    }

                    this.toast.success(successMsg);
                    //why do i need this? this.router.navigate(['/projectedit',this.projectService.projectdetails.projectInfo.id], { queryParams: { path  : 'Root/Test 9421/'}});
                    this.saving = false;
                  } else {
                    this.toast.error(failedMsg);
                    this.saving = false;
                  }
                } else {
                  this.saving = false;
                }
              } else {
                this.saving = false;
                this.sharedService.redirectToLoginPage();
              }
            });
            //} else {
            //this.saving = false;
            //this.sharedService.CalculateLCCCompleted = false;
            //}
            //});
          }
        }
      } else {
        this.sharedService.TempStringStorageTotalFail = this.sharedService.TempStringStorageTotalFail + 1;
        this.sharedService.UploadingEntry = false;
        this.sharedService.ServerDataReady = false;
      }
    },
      err => {
        this.saving = false;
        //this.toastr.error('Failed to upload Parameters.Please try again.', '');
      });
  }

  //Modified by PP(2023-10-24): Check for timeout of logincode - START
  canActivate(): boolean {
    let token = this.loginService.cookieSvc.get("CFSSLoginCode");
    this.sharedService.checkValidLogin(token).subscribe(res => {
      if (res === true) {

      } else {
        this.sharedService.invalidLoginMessage = 'Session time-out. Please login again.';
        this.sharedService.redirectToLoginPage();
        //this.toast.error('Session time-out. Please login again.', '');
        //this.loginService.cookieSvc.set("CFSSLoginCode", '');
        //this.userInfoService.userData.UserId = 0;
        //this.router.navigate(["login"]);
      }
    });
    return true;
  }
  //Modified by PP(2023-10-24): Check for timeout of logincode- END

}
